import { useContext } from 'react';
import { LocaleContext } from '@/components/providers/LocaleProvider';

const useLocale = () => useContext(LocaleContext);

export default useLocale;
